export const colors = {
    primary: '#333132',
    secondary: '#84EE91'
}